'use client'

import { cn } from '@/lib/utils'

interface ThemeToggleSwitchProps {
  isDark: boolean
  size?: 'sm' | 'md'
  className?: string
}

/**
 * Gece/gündüz anahtarı — inline stiller ile global dark bg override’larından etkilenmez.
 */
export default function ThemeToggleSwitch({
  isDark,
  size = 'md',
  className,
}: ThemeToggleSwitchProps) {
  const sm = size === 'sm'
  const trackW = sm ? 32 : 40
  const trackH = sm ? 18 : 22
  const knob = sm ? 14 : 18
  const pad = 2
  const travel = trackW - knob - pad * 2

  return (
    <span
      className={cn('theme-switch', className)}
      aria-hidden
      style={{
        position: 'relative',
        display: 'inline-block',
        width: trackW,
        height: trackH,
        flexShrink: 0,
        borderRadius: 9999,
        backgroundColor: isDark ? '#D92E2E' : '#cbd5e1',
        boxShadow: isDark
          ? 'inset 0 0 0 1px rgba(0,0,0,0.15)'
          : 'inset 0 0 0 1px rgba(0,0,0,0.08)',
        verticalAlign: 'middle',
      }}
    >
      <span
        className="theme-switch-knob"
        style={{
          position: 'absolute',
          top: pad,
          left: pad,
          width: knob,
          height: knob,
          borderRadius: 9999,
          backgroundColor: '#ffffff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.35), 0 0 0 1px rgba(0,0,0,0.06)',
          transform: `translateX(${isDark ? travel : 0}px)`,
          transition: 'transform 0.18s ease',
          display: 'block',
        }}
      />
    </span>
  )
}
